// src/socket.js

import { io } from "socket.io-client";

const SOCKET_URL = "https://boom.mouserunner.online";
const SOCKET_PATH = "/socket.io";

// ======================================================
//  🔵 1) Лобби сокет — общий канал для списка комнат
// ======================================================
export function lobbySocket(token) {
  const socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    transports: ["websocket"],
    auth: { token },
  });

  socket.on("connect", () => {
    console.log("🔌 Lobby connected:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("❌ Lobby disconnected");
  });

  return socket;
}

// ======================================================
//  🔴 2) Комнатный сокет — подключение к конкретной комнате
// ======================================================
export function roomSocket(token, roomId) {
  const socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    transports: ["websocket"],
    auth: { token, roomId },
  });

  socket.on("connect", () => {
    console.log(`🎮 Room socket connected: ${socket.id}, room=${roomId}`);

    // При входе отправляем JOIN_ROOM
    socket.emit("JOIN_ROOM", { roomId });
  });

  socket.on("disconnect", () => {
    console.log("❌ Room socket disconnected");
  });

  // Debug ошибок
  socket.on("connect_error", (err) => {
    console.error("Socket connect error:", err);
  });

  return socket;
}
